export {
  default,
  default as PracticeInformationBody,
} from "./PracticeInformationBody";
